import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Product from './pages/Product';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import Layout from './components/Layout';
import Contact from './pages/Contact';
import Success from './pages/Success';
import WebsiteBuilder from './pages/WebsiteBuilder';
import LiveDemo from './pages/LiveDemo';
import LivePreview from './pages/LivePreview';

function App() {
	return (
		<Routes>
			<Route path="website-builder/live-demo" element={<LiveDemo />} />
			<Route path="website-builder/live-preview" element={<LivePreview />} />
			<Route path="/" element={<Layout />}>
				<Route index element={<Home />} />
				<Route path="sales" element={<Contact />} />
				<Route path="book-demo" element={<Contact />} />
				<Route path="product" element={<Product />} />
				<Route path="solutions" element={<Solutions />} />
				<Route path="resources" element={<Resources />} />
				<Route path="pricing" element={<Pricing />} />
				<Route path="website-builder" element={<WebsiteBuilder />} />
				<Route path="success" element={<Success />} />
			</Route>
		</Routes>
	);
}

export default App;
